<div class="how-page py-5">
  <div class="container">
    <section class="hero-card text-center mx-auto mb-5">
      <span class="eyebrow">How the platform creates momentum</span>
      <h1 class="display-5 fw-bold mt-3 mb-3">How {{ title }} works</h1>
      <p class="lead text-muted mb-0">
        {{ title }} is designed to create an immediate shift in operational maturity. You do not just add data.
        You establish a repeatable system for maintenance, readiness, cruise planning, collaboration, and live execution.
      </p>
    </section>

    <section class="journey-card mb-5">
      <div class="text-center mb-4">
        <span class="eyebrow">Five-step workflow</span>
        <h2 class="h1 mt-2">From first login to full operational control</h2>
        <p class="text-muted mb-0">
          Each step compounds the value of the next, which is exactly why the experience starts feeling indispensable so quickly.
        </p>
      </div>

      <div class="row g-4">
        <div class="col-lg-6" *ngFor="let step of steps; let i = index">
          <article class="step-card h-100">
            <div class="d-flex align-items-start gap-3">
              <div class="step-number">{{ i + 1 }}</div>
              <div class="step-content">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <i class="{{ step.icon }} text-primary fs-4"></i>
                  <h3 class="h4 mb-0">{{ step.title }}</h3>
                </div>
                <p class="text-muted mb-3">{{ step.description }}</p>
                <div class="outcome-box">
                  <strong>Result:</strong> {{ step.outcome }}
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="impact-card mb-5">
      <div class="row g-4 align-items-center">
        <div class="col-lg-5">
          <span class="eyebrow">Why teams convert fast</span>
          <h2 class="mt-3">The payoff is visible almost immediately.</h2>
          <p class="text-muted mb-0">
            Once your boats, maintenance, routes, and people are organized inside one operating layer, the contrast with old workflows becomes impossible to ignore.
          </p>
          <p class="text-muted mt-3 mb-0">
            See these steps in practice with <a routerLink="/smart-yacht-management">smart yacht management workflows</a>,
            from maintenance reminders to voyage preparation.
          </p>
        </div>
        <div class="col-lg-7">
          <div class="impact-list">
            <div class="impact-item" *ngFor="let moment of adoptionMoments">
              <i class="bi bi-check2-circle text-success"></i>
              <span>{{ moment }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-card text-center mx-auto">
      <span class="eyebrow">Make the switch now</span>
      <h2 class="mt-3 mb-3">If your operation matters, your workflow should feel as capable as your vessel.</h2>
      <p class="text-muted mb-4">
        Every day you wait is another day spent chasing status, reconstructing history, and trusting memory where a system should be doing the work.
        Start now, choose a subscription, and let {{ title }} become the platform your team quietly refuses to live without.
      </p>
      <div class="d-flex flex-column flex-sm-row justify-content-center gap-3">
        <a routerLink="/register" class="btn btn-primary btn-lg px-4">Create your account</a>
        <a routerLink="/subscriptions" class="btn btn-outline-primary btn-lg px-4">Choose a subscription</a>
      </div>
    </section>
  </div>
</div>
